<template>
  <div class="workorderHistoryData">
    <div class="col-12 row text-center mx-0 table-responsive" style="">
      <b-table
        :items="workorderHistoryDataItem"
        :fields="workorderHistoryDataFields"
        sticky-header="480px"
        :no-border-collapse="true"
        @row-clicked="onRowClicked"
        class="table-row-click"
        :class="{
          'workorderHistoryData-table-detail': workorderHistoryTableStyle == '',
          'workorderHistoryData-table-detail-select':
            workorderHistoryTableStyle == '',
          'machStatus-components-table-workorderHistory':
            workorderHistoryTableStyle ==
            'machStatus-components-table-workorderHistory'
        }"
      >
        <template #cell(qty)="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
        <template #cell(completeQty)="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
        <template #cell(completeWeight)="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
        <template #cell(time)="data">
          <div>
            {{ data.value.split(".")[0] }}
          </div>
        </template>
        <template #cell(startTime)="data">
          <div>
            {{ data.value.split(".")[0] }}
          </div>
        </template>
        <template #cell(endTime)="data">
          <div>
            {{ data.value.split(".")[0] }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "workorderHistoryData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workorderHistoryDataFields:
        "workorderHistoryData/get_workorderHistoryDataFields",
      workorderHistoryDataItem:
        "workorderHistoryData/get_workorderHistoryDataItem",
      workorderHistoryTableStyle:
        "workorderHistoryData/get_workorderHistoryTableStyle"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_rowClickData: "workorderHistoryData/set_rowClickData"
    }),
    onRowClicked(items, index, event) {
      let vm = this;
      let obj = {
        items: items,
        index: index,
        event: event
      };
      vm.set_rowClickData(obj);
    }
  }
};
</script>

<style></style>
<style lang="scss">
.workorderHistoryData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.workorderHistoryData-table-detail th,
.workorderHistoryData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.workorderHistoryData-table-detail td {
  font-size: 1rem;
}
.workorderHistoryData-table-detail.table-row-click td {
  cursor: pointer;
}
.workorderHistoryData-table-detail th:first-child,
.workorderHistoryData-table-detail td:first-child {
  border-left: 1px solid;
}
.workorderHistoryData-table-detail-select tr th:nth-child(1),
.workorderHistoryData-table-detail-select tr td:nth-child(1) {
  width: 140px;
  min-width: 140px;
}
.workorderHistoryData-table-detail-select tr th:nth-child(2),
.workorderHistoryData-table-detail-select tr td:nth-child(2) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryData-table-detail-select tr th:nth-child(3),
.workorderHistoryData-table-detail-select tr td:nth-child(3) {
  width: 200px;
  min-width: 200px;
}
.workorderHistoryData-table-detail-select tr th:nth-child(4),
.workorderHistoryData-table-detail-select tr td:nth-child(4) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryData-table-detail-select tr th:nth-child(5),
.workorderHistoryData-table-detail-select tr td:nth-child(5) {
  width: 190px;
  min-width: 190px;
}
.workorderHistoryData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.workorderHistoryData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.workorderHistoryData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/components/workorderHistoryData.vue